// extracted by mini-css-extract-plugin
module.exports = {"tableLabel":"CustomerGold_tableLabel_15yak","tableColumn":"CustomerGold_tableColumn_VhiZ7","dangerInput":"CustomerGold_dangerInput_3lWhm"};